import { proxy } from 'valtio';
import { deepClone } from 'valtio/utils';

import { DiagramChatChannel, DiagramChatMessage } from 'models';

type ChatState = {
    channel: DiagramChatChannel['id'] | null;
    thread: DiagramChatMessage['id'] | null;
    prefillMessage: string | object;
    showAccessPopover: boolean;
    limits: {
        [channel: string]: number;
    };
};

const chatStateDefaults: ChatState = {
    channel: null,
    thread: null,
    prefillMessage: '',
    showAccessPopover: false,
    limits: {},
};

const chatState = proxy(deepClone(chatStateDefaults));

export { chatState, chatStateDefaults };
